import { fromTest } from './../../../../reducers/test.reducer';
import { fromQuestion } from './../../../../reducers/question.reducer';
import { Test } from './../../../../models/test.model';
import { Store, select } from '@ngrx/store';
import { Question } from './../../../../models/question.model';
import { Observable, take } from 'rxjs';
import { Component, OnInit, ViewChild, AfterViewInit, Input } from '@angular/core';
import { QuestionService } from 'src/app/services/question.service';
import { setQuestion } from 'src/app/actions/question.actions';

@Component({
  selector: 'ct-adn-question',
  templateUrl: './adn-question.component.html',
  styleUrls: ['./adn-question.component.scss'],
})

export class AdnQuestionComponent implements OnInit, AfterViewInit {

  @Input() colors: any;
  @ViewChild('adnExamplesModal') adnExamplesModal;

  public questions$: Observable<Question>;
  public test$: Observable<Test>;

  public currentTest: Test;
  public totalQuestions: number;
  public answers: any[] = [];
  public questionsAnswered = 0;
  public questionsInPage: number;
  public currentPercentage: number;

  constructor(
    private store: Store,
    private questionService: QuestionService,
  ) { }

  ngOnInit(): void {
    // obtenemos los datos de la pregunta y el test de la store
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.questions$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.pipe(take(1)).subscribe(test => {
      this.currentTest = test;
    });

    this.questions$.subscribe(question => {
      this.totalQuestions = question.questionsInLevel;
      this.questionsInPage = question.questions.length;
      this.currentPercentage = (question.questions[0].position - 1) * 100 / this.totalQuestions;
    });
  }

  ngAfterViewInit(): void {
    this.test$.subscribe(test => {
        this.adnExamplesModal.openModal();
    });
  }

  pushAnswer(newAnswer) {
    const previouslyAnswered = this.answers.find(answer => answer.questionId === newAnswer.questionId);
    if (previouslyAnswered) {
      previouslyAnswered.optionId = newAnswer.optionId;
    } else {
      this.answers.push(newAnswer);
      this.currentPercentage += 100 / this.totalQuestions;
      this.questionsAnswered++;
    }
  }

  public setAnswer() {
    // comprobamos si todas las preguntas están contestadas
    if (this.answers.length === this.questionsInPage) {
      this.questionService.putAnswer(this.currentTest.token, this.answers.map(answer => answer.optionId)).subscribe(res => {

        this.questionService.getNextQuestion(this.currentTest.token).subscribe(questions => {
          this.store.dispatch(setQuestion(questions));
          window.scroll(0, 0);
        }, error => {
          console.log(error);
        });

        this.answers = [];
        this.questionsAnswered = 0;

      }, error => {
        console.log(error);
      });
    }
  }

}
